import React from 'react';
import { Button } from '../ui/Button';
import { Star } from 'lucide-react';
import { DangerBanner } from './DangerBanner';
export function HeroSection() {
  return <section className="relative pt-12 pb-16 md:pt-20 md:pb-24 overflow-hidden" data-id="element-97">
      <div className="container mx-auto px-4 max-w-6xl" data-id="element-98">
        <div className="flex flex-col md:flex-row items-center gap-12" data-id="element-99">
          {/* Text Content */}
          <div className="flex-1 text-center md:text-left space-y-6" data-id="element-100">
            <div className="inline-flex items-center gap-2 bg-[#E6FFFA] text-[#285E61] px-4 py-2 rounded-full text-sm font-bold mb-2" data-id="element-101">
              <Star className="w-4 h-4 fill-current" data-id="element-102" />
              <span data-id="element-103">Para mujeres que se sienten agotadas</span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-slate-900 leading-tight" data-id="element-104">
              Cómo recuperar tu{' '}
              <span className="text-[#2C7A7B]" data-id="element-105">dignidad y valor personal</span>{' '}
              cuando tu cuerpo y mente dicen "no más".
            </h1>

            <p className="text-xl text-slate-600 leading-relaxed max-w-2xl mx-auto md:mx-0" data-id="element-106">
              Deja de odiarte por estar cansada. Descubre cómo silenciar la
              culpa y recuperar el mando de tu vida sin tener que "hacer" más.
            </p>

            <DangerBanner data-id="element-107" />

            <div className="pt-2 flex flex-col sm:flex-row gap-4 justify-center md:justify-start" data-id="element-108">
              <Button variant="primary" size="lg" withIcon onClick={() => {
              const el = document.getElementById('pricing');
              if (el) el.scrollIntoView({
                behavior: 'smooth'
              });
            }} data-id="element-109">
                QUIERO SENTIRME ÚTIL OTRA VEZ
              </Button>
            </div>

            <p className="text-sm text-slate-500 italic" data-id="element-110">
              * Acceso inmediato al Libro digital
            </p>
          </div>

          {/* Image Content */}
          <div className="flex-1 relative w-full max-w-md md:max-w-full" data-id="element-111">
            <div className="absolute inset-0 bg-[#2C7A7B] rounded-3xl rotate-3 opacity-10 blur-2xl transform scale-95" data-id="element-112"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iFruMXTKEtafX1E2JF9TGo/heylloyd-image-1771715016021.png" alt="Portada del Ebook: Cómo Sentirte Útil Cuando No Puedes Hacer Nada" className="relative z-10 w-full h-auto rounded-xl shadow-2xl transform transition-transform hover:scale-[1.02] duration-500" data-id="element-113" />
          </div>
        </div>
      </div>
    </section>;
}